import React from "react";
export const Header = () => {
  return (
    <header id={"header"} className={"l-header"}>
      <div className={"l-header-inner"}></div>
    </header>
  );
};
